
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class WIPTransactionGrid extends Serenity.EntityGrid<WIPTransactionRow, any> {
        protected getColumnsKey() { return 'Production.WIPTransaction'; }
        protected getDialogType() { return WIPTransactionDialog; }
        protected getIdProperty() { return WIPTransactionRow.idProperty; }
        protected getInsertPermission() { return WIPTransactionRow.insertPermission; }
        protected getLocalTextPrefix() { return WIPTransactionRow.localTextPrefix; }
        protected getService() { return WIPTransactionService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}